var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinanceImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #262627;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1, .st2, .st4, .st5 {\n        stroke-width: 1.2px;\n      }\n\n      .st6 {\n        fill: #262627;\n      }\n\n      .st7 {\n        fill: #f4cc4d;\n      }\n\n      .st8 {\n        fill: #fff;\n      }\n\n      .st9 {\n        fill: #3498db;\n      }\n\n      .st10 {\n        fill: #c9a645;\n      }\n\n      .st1 {\n        stroke: #fff;\n      }\n\n      .st11 {\n        fill: #ffcfc0;\n      }\n\n      .st2 {\n        stroke: #ff8e77;\n      }\n\n      .st12 {\n        fill: #bac8e5;\n      }\n\n      .st3 {\n        stroke-width: 3.1px;\n      }\n\n      .st3, .st5, .st13 {\n        stroke: #0671ad;\n      }\n\n      .st14 {\n        fill: #171659;\n      }\n\n      .st4 {\n        stroke: #f4cc4d;\n      }\n\n      .st13 {\n        fill: #0671ad;\n        stroke-width: 1.5px;\n      }\n\n      .st15 {\n        fill: #ff8e77;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M289.6,191H93.3c-4.2,0-7.7-3.4-7.7-7.7V42.6c0-4.2,3.4-7.7,7.7-7.7h196.3c4.2,0,7.7,3.4,7.7,7.7v140.7c0,4.2-3.4,7.7-7.7,7.7h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134.7,103.2h-8v19.4h8v-19.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M146,100.5h-8v22.1h8v-22.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M150.3,121.7v-24.5h6.1v24.5h-6.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M168.6,86.6h-8v36.1h8v-36.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.9,76.6h-8v46h8v-46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M191.2,81.7h-8v40.9h8v-40.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M195.5,121.7v-42.2h6.1v42.2h-6.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,63.2v59.4h106.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.2,113l20.9-24.5,8.8,9.3,35.7-30.1,11.4,10.4,17.8-13.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,65.4c.6,0,1.1-.5,1.1-1.1s-.5-1.1-1.1-1.1-1.1.5-1.1,1.1.5,1.1,1.1,1.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.3,113c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M154.9,139.1h-49.2v25.7h49.2v-25.7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,139.1h28.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,144.3h42.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,149.4h42.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,154.6h42.2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,159.7h42.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.1,164.8h42.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,56.1h28.4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,61.2h42.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,66.3h42.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,71.5h42.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,76.6h42.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,81.7h42.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,96.9h28.4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,102.1h42.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,107.2h42.2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,112.4h42.2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,117.5h42.2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,122.6h42.2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M272.1,168.9h-32c-2.3,0-4.2-1.9-4.2-4.2v-25.5c0-2.3,1.9-4.2,4.2-4.2h32c2.3,0,4.2,1.9,4.2,4.2v25.5c0,2.3-1.9,4.2-4.2,4.2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M265.8,147.5c0-5.5-4.5-9.9-10.1-9.7-5,.2-9.1,4.4-9.3,9.4,0,3.4,1.6,6.4,4.1,8.2.9.6,1.3,1.6,1.3,2.6v.5c0,.7.6,1.4,1.4,1.4h5.7c.8,0,1.4-.6,1.4-1.4v-.5c0-1,.5-2,1.4-2.6,2.5-1.8,4.1-4.6,4.1-7.9h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.3,151.8h.7l.4.6.8-1,.4.9.4-.6h.8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.8,159.9l-.4-7.9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.4,159.9l.4-7.9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M257.3,166.1h-2.4c-1,0-1.9-.8-1.9-1.9v-4.3h6.1v4.3c0,1-.8,1.9-1.9,1.9Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253,161.2h6.1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253,162.4h6.1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253,163.6h6.1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253,164.8h6.1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20.2,202.2c5.8,22.1,28.4,35.3,50.5,29.5,22.1-5.8,35.3-28.4,29.6-50.5-5.8-22.1-28.4-35.3-50.5-29.6-22.1,5.8-35.3,28.4-29.6,50.5Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.9,197.4c5.8,22.1,28.4,35.3,50.5,29.5,22.1-5.8,35.3-28.4,29.6-50.5-5.8-22.1-28.4-35.3-50.5-29.6-22.1,5.8-35.3,28.4-29.6,50.5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24.9,195.8c4.9,18.8,24.1,30,42.9,25.1s30-24.1,25.1-42.9c-4.9-18.8-24.1-30-42.9-25.1-18.8,4.9-30,24.1-25.1,42.9h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47,192.5c.9-1.7,2.1-3.1,3.6-4.2,1.3-1,3-2,5.1-3.1.3-.2.7-.4,1-.5,1.6-.9,2.9-1.6,3.9-2.2.1,0,.3-.2.4-.2,1-.7,1.8-1.4,2.4-2.3s.7-1.8.5-2.8c-.4-1.5-1.3-2.5-2.9-3.1-.8-.3-1.6-.4-2.7-.4-1,0-2.2.2-3.6.6-.6.1-1.2.3-1.8.6-1,.4-2,.9-3,1.5-1.6.9-3,2.1-4.4,3.4l-3.5-4.6c1.3-1.4,2.9-2.7,4.9-3.8,1.5-.8,3-1.5,4.5-2l-1.4-5.3,5.3-1.4,1.4,5.5c1.7-.2,3.3-.2,4.8,0,2.4.4,4.4,1.3,5.9,2.6,1.5,1.4,2.5,3,3,5,.6,2.4.5,4.4-.3,6.1-.9,1.7-2.1,3.1-3.6,4.2-1.2.8-2.6,1.7-4.4,2.7-.6.3-1.2.6-1.8,1-1.2.7-2.3,1.3-3.2,1.8-.4.2-.8.5-1.2.7-1,.7-1.8,1.4-2.4,2.3-.6.9-.7,1.8-.4,2.8.4,1.4,1.3,2.4,2.9,2.9.9.3,2.1.4,3.5.3.9,0,1.8-.3,2.9-.5.8-.2,1.6-.5,2.4-.8,1.3-.5,2.6-1.2,3.8-2,1.9-1.3,3.5-2.7,4.7-4.3l3.7,4.6c-1.2,1.7-2.9,3.3-5.3,4.7-1.7,1-3.4,1.9-5.3,2.5l1.4,5.4-5.3,1.4-1.4-5.4c-2,.3-3.9.3-5.5,0-2.5-.4-4.4-1.2-5.9-2.6-1.5-1.3-2.5-3-3-5-.6-2.3-.5-4.3.4-6h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M100.7,210.2l30.8-21.5c5.7-4,13.6-1.8,16.5,4.5l14.6,31.6h-17.6l-8.6-21-25,19.1-10.8-12.7h0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.7,221.3s8.1-10.6,16-12.1l-6.4,23.9h-11.9l2.3-11.8h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.2,172.7c-.7-3.3-2.4-6.2-4.7-8.5-2.1-2.1-4.7-3.7-7.6-4.6v16.9h2.4s6.5,32.7,6.5,32.7l.8,3.9,10.5-5.2-7.9-35.2h0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M71.7,213.9l1.4,8.2c1.1,6.3,6.6,11,13,11h87.3l1.7-14h-69.6l-4.4-12.1-29.4,6.9h0Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.6,204.3l1.4,4.2-2.1.7-28.6,8.9c-.5.1-1-.2-1-.7l-.5-3.9c-.6-.3-1.1-.8-1.4-1.3-.3-.5-.5-1.2-.6-1.9-.7-13.9.4-32,1.2-42.8-.5-2.1-1.5-3.6-3.1-4.7,1.1-.9,2.3-1.6,3.6-2.2,1.2-.6,2.6-1,4-1.3l1.4-.3,10.9,12,4.6-11.7h.4c0,.1.1.2.2.2,2.9.9,5.6,2.4,7.6,4.6,1.1,8.4.6,16.9,0,21.6-.3,2.6.2,5.2,1.3,7.6l2.2,4.8c1,2.1.3,4.7-1.5,6h0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91.3,159.4l-2.7,6.9-1.9,4.8-3.8-4.2-7.1-7.8,1-.2c.8-.2,1.5-.7,1.9-1.4.6.1,1.4.3,2.3.4,2.2.4,5.4.6,8.2.2,0,.3.2.5.5.7.1,0,.3.2.4.2l1.2.3h0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.4,134.9h0c-1.5-3.9-5.1-6.8-9.7-7.1-5.1-.4-9.8,2.8-11.4,7.7-1.4,4.5,0,9,3.2,11.8h0c0,.1-1.1,6.4-1.1,6.4l-.5,3.1c0,.3-.2.6-.3.8,1.9.4,6.5,1.3,10.6.6,0-.1,0-.3,0-.4l.3-2.8c6.1,2,7.9-4.5,9.5-14.4h0c.3-2,0-3.9-.6-5.7h0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.4,134.9h0c-1.2,3.5-11.6-1.6-11.6-1.6-1.1,6.6-4.4,11.9-6.2,14h0c-3.2-2.9-4.7-7.4-3.2-11.9,1.6-4.8,6.3-8,11.4-7.7,4.6.3,8.2,3.3,9.7,7.1h0Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.7,140.8s-2.1,3.8,2.7,6l-3.9,1.7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4,144.1c0,.5,0,.9.2,1,.2,0,.5-.3.6-.8,0-.5,0-.9-.2-1-.2,0-.5.3-.6.8Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M88.6,142.5c0,.5,0,.9.2,1,.2,0,.5-.3.6-.8,0-.5,0-.9-.2-1s-.5.3-.6.8Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M83.2,143.4s-1.2-5.4-4.8-4.3c-3.5,1.1-2.2,11.8,3.8,9.3l1-5h0Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.4,145.1s-.1-3-1.8-3.8c-1.7-.8-1.7,1.4-1.7,1.4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.2,142s-2.1,1.1-.4,4.2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,137.8s1.8-.5,3.1.6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.8,139.5s1.6-.7,2.3.8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.7,148.5s.2,2.4,3,3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.6,154.9l-.3,3.1c-7.4-2.2-6.7-9-6.7-9,0,0,2.2,4.7,7,5.9Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.3,195.7l9.1-4.2c1.5-.7,3.2-.4,4.5.6,2.3,2,4.6,3.2,5.5,5.4,1.3,3.5-6.7,3.2-6.7,3.2,0,0-5.1,3.5-10.3,2l-2-7h0Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.4,198.3s4.8-.4,6.3,1.4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.1,195.8s4.5-.6,7.4,1.8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.7,192.9s3.2.2,6.1,2.4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.9,162.9c-2.9,2.3-5,5.4-6,9.1-2.2,8-4.6,19.6-4.2,31.5.2,5.7,6,9.6,11.4,7.7l17.9-6.3-3.5-11.8-12.9,4.8,1-21.6c0-7.1-.4-11-3.7-13.4h0Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.9,164.3l1.7,2-1.9,4.8-3.8-4.2,1.3-2.6-3.2-6.3c2.2.4,5.4.6,8.2.2,0,.3.2.6.5.7l-2.8,5.4h0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91.3,159.4l-1.8,4.6-4.9-5.7c1.5,0,3.1,0,4.6-.2,0,.4.4.8.9.9l1.2.3Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.6,158.4l-4.1,5.9-4.7-5.2,1-.2c.8-.2,1.5-.7,1.9-1.4,1.2.3,3.4.7,5.9.8h0Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.5,164.3l4.1-5.9,4.9,5.7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,197.8c-4.2,1.4-7.3,4-7.3,4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,209.2l2.1-.7-1.4-4.2c1.9-1.4,2.5-3.9,1.5-6.1l-2.2-4.8c-1.1-2.4-1.5-5-1.3-7.6.5-6.1,0-12.3-1.9-16.2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.6,176.2l-1,21.6,12.9-4.8.7,2.2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,203l.5,1.8-17.2,6.1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.7,213.1l26.6-8.3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125.5,218h0c0,0,0,.1-.2.1h-36c-.1,0-.2-.1-.2-.2h0l7-25.8h0c0,0,0-.1.2-.1h36c.1,0,.2.1.2.2l-7,25.8h0Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,192.4l-6.9,25.8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.3,203.7l3.2,12.4c.5,1.8,2.1,3,3.9,3h30.5c.9,0,1.6-.9,1.3-1.7l-3.5-13.7h-35.4Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.8,219.1h17.3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8,159.1l10.9,12,5-11.6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M75.6,89v23.7c0,4.3-3.5,7.8-7.8,7.8h-7.1v12.8l-12.8-12.8h-16.3c-4.3,0-7.8-3.5-7.8-7.8v-23.7c0-4.3,3.5-7.8,7.8-7.8h36.2c4.3,0,7.8,3.5,7.8,7.8Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M39.9,107.2c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6,1.2-2.6,2.6-2.6,2.6,1.2,2.6,2.6Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M52.3,107.2c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6,1.2-2.6,2.6-2.6,2.6,1.2,2.6,2.6Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.7,107.2c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6,1.2-2.6,2.6-2.6,2.6,1.2,2.6,2.6Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,196.5h-52.6v36.5h52.6v-36.6h0Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.6,196.5v36.5h-18.4c-15.9-8.2-16.3-27.2-15.4-36.6h33.9Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,224.5h52.9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,214.8h52.9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,205h52.9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M285.6,192.9c7.7,12.3,3.9,28.5-8.4,36.2-12.3,7.7-28.6,3.9-36.2-8.4-7.7-12.3-3.9-28.5,8.4-36.2,12.3-7.7,28.5-3.9,36.2,8.4h0Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M283.9,190.2c7.7,12.3,3.9,28.5-8.4,36.2-12.3,7.7-28.6,3.9-36.2-8.4-7.7-12.3-3.9-28.5,8.4-36.2,12.3-7.7,28.5-3.9,36.2,8.4h0Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M280.6,192.3c6.5,10.5,3.3,24.3-7.2,30.8-10.5,6.5-24.3,3.3-30.8-7.2s-3.3-24.3,7.2-30.8,24.3-3.3,30.8,7.2h0Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M269.4,201c-1.2-.3-2.3-.4-3.5-.2-1,.2-2.2.5-3.7,1-.2,0-.5.1-.7.2-1.1.4-2,.6-2.8.8-.1,0-.2,0-.3,0-.8.2-1.5.2-2.1.1s-1.1-.5-1.5-1c-.5-.8-.6-1.7-.2-2.6.2-.5.5-.9,1-1.4.5-.5,1.1-.9,1.8-1.4.3-.2.7-.4,1-.6.6-.3,1.3-.6,2-.8,1.1-.3,2.3-.5,3.5-.5l-.6-3.6c-1.2,0-2.5.2-3.9.6-1,.3-2,.7-2.9,1.2l-1.9-3-2.9,1.8,1.9,3.1c-.9.7-1.5,1.4-2.1,2.2-.9,1.3-1.3,2.6-1.4,3.9,0,1.3.3,2.5,1,3.6.8,1.3,1.8,2.2,3,2.5,1.2.4,2.3.4,3.5.2.9-.2,2-.5,3.2-.8.4-.1.8-.2,1.2-.4.9-.3,1.6-.5,2.2-.7.3,0,.6-.2.8-.2.8-.2,1.5-.2,2.1-.1.6.1,1.1.5,1.5,1,.5.8.5,1.6,0,2.6-.3.6-.7,1.1-1.4,1.7-.4.4-.9.7-1.5,1.1-.5.3-.9.5-1.4.8-.8.4-1.7.7-2.6.9-1.5.3-2.8.4-4,.3l.5,3.7c1.3.2,2.8,0,4.5-.4,1.2-.3,2.4-.8,3.5-1.4l1.9,3,2.9-1.8-1.9-3c1-.8,1.9-1.6,2.5-2.5.9-1.3,1.4-2.6,1.4-3.9s-.3-2.5-1-3.6c-.8-1.3-1.8-2.1-3-2.5h0Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.6,233h0c-8.2-.5-15.9-4.9-20.6-12.3-.3-.5-.5-.9-.8-1.4-.3-.4-.6-.9-.9-1.3-4.2-6.7-5-14.5-2.8-21.5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M322,226.8c-2.4-.2-2.8-1.4-6-1.4s-3.9,1.9-5.9,1.9-1.2-.2-1.5-.6l.6-6.2h9.2c1.4,1.7,2.6,4,3.6,6.2h0Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M324.6,233.1h-16.6l.6-6.3c.3.3.8.6,1.5.6,2,0,2.3-1.9,5.9-1.9s3.6,1.1,6,1.4c1.5,3.3,2.5,6.3,2.5,6.3h0Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M283.2,229.2c3.9-1.3,10.8-3.4,14.4-2.8v-5.9h-9.1c-3.2,2-6.9,5.2-9.8,7.9.3.8,1.4,1.8,4.5.8h0Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M283.2,229.2c-3.1,1-4.1,0-4.5-.8-2.7,2.6-4.7,4.6-4.7,4.6h23.6v-6.6c-3.7-.6-10.6,1.5-14.5,2.8h0Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325,85.2c-.1,3.2-6.2,7.8-6.2,7.8,0,0-16-1.6-20-2.8s-5.4-5.3-2.9-7.6c2.5-2.2,3.8-6.6-.3-6.6-4.1,0-3.4-3.7-3.4-3.7-1.2-.1-3.3-1.4-3.4-4.1,0-2.8,3.3-4,3.3-4-.8-.6-2.2-6.9,8.7-10.9,1.2-.4,2.3-.7,3.3-.9,7.9-1.6,8.9,3.8,8.9,3.8,11,1.2,5.1,16.1,5.1,16.1,0,0,2.4,0,2.4,2.2s-2.8,3.5-2.8,3.5c0,0,1.7-.2,2.8.5.4.2.6.6.7,1.2.4,2-1.8,3.7-2.1,3.9,2.6-1.3,6.2-1.5,6,1.7h0Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M286.6,109.6l-2.5,2.6-.4-.4h0l-6.8-6.9c1.9-2.7,3.9-5.1,5.8-7.1h0c2.2-2.4,4.5-4.3,6.9-5.9h0c4.5-2.9,9.2-4.4,14.6-4.4s6.1.4,8.7,1c3.7.9,7,2.9,9.4,5.7h0c1.7,2,3,4.3,3.6,6.9h0c0,.2.1.4.2.7l2,8.6-.6,2.1-6.8,2.9h0l-.9.4-2-7.7h0l-1.2-4.5-.2-.7h-23.6l-.3.3-6.1,6.5h0Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M328.4,113.2l-3.8,13.7c-.3-.4-.5-.9-.6-1.4l-2.7-9.2,7.2-3.1Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M295,126.8l-4.4,7.4-16-13.7c-3.3-2.8-4-7.6-1.7-11.2,1-1.5,1.9-3,2.9-4.3l7.3,7.5-2,2,13.9,12.4h0Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M314.5,112h0c-1.4,3.4-1.7,7.2-.7,10.7h0c.7,2.6,1.3,5.4,1.8,8.3h-25.3c1.2-7.3,1.3-11.8-1.4-17.5h0c-.5-1-.7-2.1-.8-3.2h0c-.2-2.6.4-5.3,1.1-7.5.3-1.1.7-2,1-2.6.1-.3.2-.6.3-.7,0,0,0-.1,0-.2h0c0,0,.1-.3.1-.3v-.3s-.7-7.1-.7-7.1c2-1.2,4-2.2,6.1-2.9,0,.7.2,1.6.7,2.3.9,1.4,2.5,2.5,5.4,2.5,5,0,8.7-3.3,10.3-5.1.1,0,.2,0,.4,0,3.5.8,6.6,2.7,9,5.3l-5.9,14.2h0l-1.6,4h0Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M316.7,131.9h-27.5c0,.3-.1.7-.2,1-1.6,8.6-5.4,88.3-5.4,88.3h16.3l2.6-71.3,3.2,71.3h15.2s-2-64.3-2.8-75.6c-.3-5.1-.8-9.6-1.4-13.7h0Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M310.2,75.5l-.2,10.5c0,.6.4,1.1,1,1.2.4,0,.9.1,1.3.2-1.4,1.6-5,5.2-10,5.2s-5.2-3.7-5.1-5.1c.6-.1,1.1-.3,1.7-.4.5-.1.9-.6.9-1.1v-.8c0,0,.4-4,.4-4-6.2.8-6.7-5.8-6.4-15.5h0c.2-6.2,5.7-11.1,12.2-10.3,4.9.6,8.9,4.6,9.4,9.5.5,4.6-1.7,8.6-5.3,10.7h0Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.4,78.5h-7.5c-3.6-4.2-3.3-11.9-3.3-11.9-8.7-3.6-5.5-12.2-5.5-12.2v-2.1c7.9-1.6,8.8,3.8,8.8,3.8,11,1.2,5.1,16.1,5.1,16.1,0,0,2.4,0,2.4,2.2s-2.8,3.5-2.8,3.5c0,0,1.7-.2,2.8.5h0Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M305.1,74.6s-.5.6-1.1,1.2c-1.5,1.4-4,3.1-4.5-.5h.3s5.4-.7,5.4-.7h0Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305.1,74.6s-.5.6-1.1,1.2c-3.2,1.2-4,.2-4.2-.5l5.4-.7h0Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.3,68.7c0,1.5-1.4,2.8-3.2,2.8s-3.2-1.2-3.2-2.8,1.4-2.8,3.2-2.8,3.2,1.2,3.2,2.8Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.5,71.4c1.8,0,3.2-1.2,3.2-2.8s-1.4-2.8-3.2-2.8-3.2,1.2-3.2,2.8,1.4,2.8,3.2,2.8Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.8,66.4s1.3,4.1-3.7,5.3l3.4,2.3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.3,68.7s.7-1,2.1,0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.3,68.6c0,.5-.2.9-.4.9s-.4-.4-.4-.9.2-.9.4-.9.4.4.4.9Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304.7,69.5c.2,0,.4-.4.4-.9s-.2-.9-.4-.9-.4.4-.4.9.2.9.4.9Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.2,63.5s1.7-1.4,3.8-.5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.1,62.9s2.2-1.3,4.9,0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.7,68.7l5.8,1.2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M308.7,78c-.2.3-3.3,5.4-8.8,7.2l.3-4c5.7-.3,8.3-3,8.4-3.2h0Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M309.7,73.1s2.2-4.9,5.4-3.2c3.2,1.7,0,11.7-5.4,8.2v-4.9Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.1,75.1s.7-2.8,2.4-3.3c1.7-.5,1.4,1.7,1.4,1.7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.8,72.3s1.8,1.5-.4,4.1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.3,110.3c-.4-5.5,2.6-11.5,2.6-11.5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.9,103.8l1.2,4.5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,97c-.1,1.8-.1,4.8-1,7.1-.4,3.4-.9,6.7-1.4,9.8,0,0,0,0,0,0-.7,3.9-1.4,7.6-2.2,11.1-.1.5-.3,1-.5,1.4-1.9,3.7-7.3,3.9-9.4.4l4.6-16.5,2.1-7.5-1.4-6.8c-.3-1.2-.1-2.5.5-3.7,1.4-2.9,4.3-8.4,5.8-7.8,1.9.9-1.9,3.4-2.6,7.9,0,0,5-8.8,6.7-7.4,1.7,1.4-2,2.9-4,7.8.2-.3,4.4-5.8,5.5-4.7,1.2,1.2-2.6,3.3-4,6.4.2-.2,3.3-4,4.5-3.3,1.2.8-3,3.7-3.1,5.5h0Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.4,113.2l-1.8,6.4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M331.4,94.5s4.7-4.7,6-3.1c1.3,1.6-2.1,2.7-2.3,3.7,0,0,.7,2.2.3,3.6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.4,94.5s4.7-4.7,6-3.1c1.3,1.6-2.1,2.7-2.3,3.7,0,0,.7,2.2.3,3.6"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.7,50.4s.1-10.8,10.9-10.8c0,0-10.9-.2-10.8-10.9,0,0-.1,10.8-10.9,10.8,0,0,10.9.2,10.8,10.9Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M325.7,58.3s0-5.4,5.4-5.4c0,0-5.4,0-5.4-5.4,0,0,0,5.4-5.4,5.4,0,0,5.4,0,5.4,5.4Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,233.1h322.4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.3,199.8c.5-4.9,4.6-8.8,9.7-8.8h1.2v-1c-.2-.5-.2-1-.2-1.5,0-8.5,6.9-15.4,15.4-15.4s12.4,4.2,14.5,10.2l.3.8.8-.2c1-.3,2.1-.4,3.2-.4,6.4,0,11.6,4.8,12.3,10.9l.2,1.6,1.3-1c1.2-1,2.8-1.5,4.5-1.5,3.7,0,6.8,2.8,7.3,6.4h-70.5Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M47.5,50.9c.5-6,5.5-10.8,11.7-10.8h1.2v-1c-.2-.6-.2-1.2-.2-1.8,0-10.2,8.3-18.5,18.5-18.5s14.8,5.1,17.3,12.1l.3.8.8-.2c1.2-.3,2.5-.5,3.8-.5,7.6,0,13.9,5.7,14.7,13.1l.2,1.6,1.3-1c1.5-1.2,3.4-1.8,5.4-1.8,4.6,0,8.3,3.5,8.8,7.9H47.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceImage);
export default __webpack_public_path__ + "static/media/finance-image.32114006286b27dad47324beb729b806.svg";
export { ForwardRef as ReactComponent };